import React from "react";

// Message proposant à un PRO (sans fiche) de créer sa fiche Pro (annuaire).
// Montré 1 fois (nouvel inscrit pro OU passage en pro depuis le profil). Non bloquant.
// Autonome (aucune dépendance app), rouge de marque en dur.

const I18N = {
  fr: { title:"Tu es un Pro ! 🐴", body:"Crée ta fiche Pro pour apparaître dans l'annuaire (carte + recherche) et être trouvé par les cavaliers près de chez toi.", create:"Créer ma fiche Pro", later:"Plus tard" },
  en: { title:"You're a Pro! 🐴", body:"Create your Pro listing to appear in the directory (map + search) and be found by riders near you.", create:"Create my Pro listing", later:"Later" },
  de: { title:"Du bist ein Profi! 🐴", body:"Erstelle deinen Profi-Eintrag, um im Verzeichnis (Karte + Suche) zu erscheinen und von Reitern in deiner Nähe gefunden zu werden.", create:"Profi-Eintrag erstellen", later:"Später" },
  es: { title:"¡Eres un Pro! 🐴", body:"Crea tu ficha Pro para aparecer en el directorio (mapa + búsqueda) y que te encuentren los jinetes cerca de ti.", create:"Crear mi ficha Pro", later:"Más tarde" },
  it: { title:"Sei un Pro! 🐴", body:"Crea la tua scheda Pro per apparire nell'elenco (mappa + ricerca) ed essere trovato dai cavalieri vicino a te.", create:"Crea la mia scheda Pro", later:"Più tardi" },
  pt: { title:"És um Pro! 🐴", body:"Cria a tua ficha Pro para apareceres no diretório (mapa + pesquisa) e seres encontrado pelos cavaleiros perto de ti.", create:"Criar a minha ficha Pro", later:"Mais tarde" },
  nl: { title:"Je bent een Pro! 🐴", body:"Maak je Pro-fiche aan om in de gids te verschijnen (kaart + zoekfunctie) en gevonden te worden door ruiters in je buurt.", create:"Mijn Pro-fiche aanmaken", later:"Later" },
};

export default function CreateFicheNotice({ lang = "fr", onCreate, onDismiss }) {
  const t = I18N[lang] || I18N.fr;
  return (
    <div onClick={onDismiss} style={{
      position:"fixed", inset:0, zIndex:2000, background:"rgba(0,0,0,.6)",
      display:"flex", alignItems:"center", justifyContent:"center", padding:20,
    }}>
      <div onClick={e=>e.stopPropagation()} style={{
        width:"100%", maxWidth:380, background:"#1A1A2E", color:"#fff",
        borderRadius:18, padding:"22px 20px 18px", border:"1px solid rgba(255,255,255,.12)",
        boxShadow:"0 20px 50px rgba(0,0,0,.5)", textAlign:"center",
      }}>
        <div style={{ fontSize:19, fontWeight:900, fontFamily:"var(--fh)", marginBottom:10 }}>{t.title}</div>
        <div style={{ fontSize:13.5, color:"rgba(255,255,255,.75)", lineHeight:1.6, marginBottom:20 }}>{t.body}</div>
        <button onClick={onCreate} style={{
          width:"100%", padding:"13px 20px", borderRadius:13, border:"none", cursor:"pointer",
          background:"#C8001A", color:"#fff", fontSize:15, fontWeight:800, fontFamily:"var(--fh)",
          boxShadow:"0 8px 22px rgba(200,0,26,.45)", marginBottom:10,
        }}>{t.create}</button>
        <button onClick={onDismiss} style={{
          width:"100%", padding:"11px 20px", borderRadius:13, cursor:"pointer",
          background:"transparent", color:"rgba(255,255,255,.55)", fontSize:13, fontWeight:600,
          border:"1px solid rgba(255,255,255,.15)",
        }}>{t.later}</button>
      </div>
    </div>
  );
}
